import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";  // Added Firestore

const firebaseConfig = {
  apiKey: "AIzaSyBEcCghNIx1fXdEDx5ZXI4VovDSmbKVlbQ",
  authDomain: "app-scale.firebaseapp.com",
  projectId: "app-scale",
  storageBucket: "app-scale.appspot.com",
  messagingSenderId: "197406527550",
  appId: "1:197406527550:web:6af82d76cc9306035b016f",
  measurementId: "G-L6EE9BY3DR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Firestore Database
export const db = getFirestore(app); // Firestore is required for knowledge packs